import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=4a052639&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a052639')) {
      api.createRecord('4a052639', component.options)
    } else {
      api.reload('4a052639', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=4a052639&", function () {
      api.rerender('4a052639', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2S6lyemDqHjrb/JS/comp/ImgFallback.vue"
export default component.exports